import React from 'react';
import { GRADE_LABELS, clampGrade } from '../lib/format';

function GradeBadge({ rating, withTitle = true }) {
    const grade = clampGrade(rating);
    const label = GRADE_LABELS[grade];

    return (
        <span
            className={`grade-badge grade-${grade}`}
            data-num={grade}
            title={withTitle ? `Grade ${grade}: ${label}` : undefined}
        >
            {label}
        </span>
    );
}

export default GradeBadge;
